import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, FileText, Flag, LogOut, KeyRound } from "lucide-react";
import Logo from "@/components/Logo";
import { hasAccess } from "@/lib/roles";

export default function AgentLayout() {
  const { user, loading, logout } = useAuth();
  if (loading) return <div className="p-12 text-navy/60">Loading…</div>;
  if (!user) return <Navigate to="/agent/login" replace />;
  if (!hasAccess(user.role, "agent")) return <Navigate to="/" replace />;

  const items = [
    { to: "/agent", i: LayoutDashboard, label: "Dashboard", end: true },
    { to: "/agent/leads", i: Users, label: "Leads" },
    { to: "/agent/tax-records", i: FileText, label: "Tax Records" },
    { to: "/agent/flags", i: Flag, label: "Flags" },
  ];

  return (
    <div className="min-h-screen flex bg-[#F7F5F0]">
      <aside className="w-64 bg-navy text-white flex flex-col p-6" data-testid="agent-sidebar">
        <div className="mb-10 flex items-center gap-3">
          <Logo size={36} color="#F7F5F0" />
          <div>
            <div className="font-serif text-2xl">Aperture</div>
            <div className="eyebrow" style={{ color: "#C4A265", fontSize: "0.55rem" }}>Agent Portal</div>
          </div>
        </div>
        <div className="mb-4 px-1 text-[10px] uppercase tracking-widest text-white/40">
          FloridaTaxProperty.com
        </div>
        <nav className="flex-1 space-y-1">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`agent-nav-${it.label.toLowerCase().replace(/\s+/g,"-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors duration-300 ${isActive ? "bg-gold text-navy" : "text-white/70 hover:text-gold"}`}>
              <it.i className="w-4 h-4" strokeWidth={1.5} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="pt-4 mt-4 border-t border-white/10 text-[11px] text-white/40 leading-relaxed">
          Signed in as<br />
          <span className="text-white/60">{user.email}</span><br />
          <span className="text-gold uppercase tracking-widest">{user.role}</span>
        </div>
        <NavLink to="/change-password" data-testid="agent-nav-change-password" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-gold transition-colors mt-2">
          <KeyRound className="w-4 h-4" /> Change my password
        </NavLink>
        <button onClick={logout} data-testid="agent-logout" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-gold transition-colors">
          <LogOut className="w-4 h-4" /> Sign out
        </button>
      </aside>
      <main className="flex-1 p-10 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}
